import React from 'react';
import { BacktestTabs, Backtest } from '@components';

export const BacktestPage = () => (
  <>
    <BacktestTabs />
    <Backtest />
  </>
);
